import { useEffect, useState } from 'react';
import { trackEvent } from '@/utils/analytics';

// Just above the slowest healthy boot measured (about 9s), so a normal load never shows it.
export const SLOW_LOAD_NOTICE_MS = 10000;

/** True once `isWaiting` has held for {@link SLOW_LOAD_NOTICE_MS}; logs one event per showing. */
const useSlowLoadNotice = (isWaiting: boolean): boolean => {
	const [isShown, setIsShown] = useState(false);

	useEffect(() => {
		if (!isWaiting) {
			setIsShown(false);
			return undefined;
		}

		const timer = setTimeout(() => {
			setIsShown(true);
			trackEvent('notice_shown', { notice_type: 'slow_connection' });
		}, SLOW_LOAD_NOTICE_MS);

		return () => clearTimeout(timer);
	}, [isWaiting]);

	return isShown;
};

export default useSlowLoadNotice;
